import { bool, elementType, func, number, object, string } from "prop-types";
import { memo, useMemo, useState } from "react";

import styled from "styled-components";

import SettingsButton from "NavBar/components/settings/SettingsButton";

import FnrOpacityToggle from "UI/FnrOpacityToggle";

import Header from "./Header";

const SettingsAndHeader = memo(
  ({
    count,
    settingsCount,
    isActive,
    navSectionKey,
    buttonRef,
    headerTextRef,
    color,
    icon,
    label,
    SettingsContent,
    settingsAndHeaderWrapperRef,
    settingsSelected,
    directSettingsAction,
    isSquiggleFlashing,
    settingsButtonRef,
    isSettingsFlashing,
    onHeaderMouseEnter,
    defaultRoute,
    HeaderSuffixComponent,
  }) => {
    const [closeTrigger, setCloseTrigger] = useState({});
    const headerCount = useMemo(
      () => (count || 0) + (settingsCount || 0),
      [count, settingsCount]
    );

    return (
      <SettingsAndHeaderWrapper
        ref={settingsAndHeaderWrapperRef}
        $isActive={isActive}
      >
        <Header
          navSectionKey={navSectionKey}
          isActive={isActive}
          ref={buttonRef}
          color={color}
          icon={icon}
          label={label}
          count={headerCount}
          isSquiggleFlashing={isSquiggleFlashing}
          headerTextRef={headerTextRef}
          onHeaderMouseEnter={onHeaderMouseEnter}
          defaultRoute={defaultRoute}
          HeaderSuffixComponent={HeaderSuffixComponent}
        />
        {Boolean(SettingsContent) && (
          <SFnrOpacityToggle show={isActive}>
            <SettingsButton
              navSectionKey={navSectionKey}
              count={settingsCount}
              selected={settingsSelected}
              closeTrigger={closeTrigger}
              settingsContentProps={{ setCloseTrigger, closeTrigger }}
              Content={SettingsContent}
              directAction={directSettingsAction}
              settingsButtonRef={settingsButtonRef}
              isSettingsFlashing={isSettingsFlashing}
            />
          </SFnrOpacityToggle>
        )}
      </SettingsAndHeaderWrapper>
    );
  }
);

const SFnrOpacityToggle = styled(FnrOpacityToggle)`
  position: absolute;
  right: 4px;
  top: 4px;
`;

// display: flex eliminates line-box sizing differences between Safari and Chrome
// caused by the icon's negative-margin pattern (see Header.jsx).
const SettingsAndHeaderWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 12px 0 12px;
  /* Top spacing uses a ::before pseudo-element instead of padding-top so
     that the height change is part of the content-box.  ResizeObserver only
     watches content-box by default, so a padding-top transition would not
     trigger useHeight to update, leaving the NavSection height stale. */
  &::before {
    content: "";
    display: block;
    height: ${({ $isActive }) => ($isActive ? 12 : 5)}px;
  }
`;

SettingsAndHeader.propTypes = {
  count: number,
  settingsCount: number,
  isActive: bool,
  navSectionKey: string,
  buttonRef: object,
  headerTextRef: object,
  color: string,
  icon: string,
  label: string,
  SettingsContent: elementType,
  settingsAndHeaderWrapperRef: object,
  settingsSelected: bool,
  directSettingsAction: func,
  isSquiggleFlashing: bool,
  settingsButtonRef: object,
  isSettingsFlashing: bool,
  onHeaderMouseEnter: func,
  defaultRoute: string,
  HeaderSuffixComponent: elementType,
};

export default SettingsAndHeader;
